import React from "react";
import { useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";

import { featureFlagSelector } from "src/store/system/selector";

import DialogTitle from "../DialogTitle";
import type Step from "../Step";

interface WhatnotImportInProcessProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

function WhatnotImportInProcess({
  onClose,
  onStepChange,
}: WhatnotImportInProcessProps) {
  const canAmazonIntegration =
    useSelector((state) => featureFlagSelector(state, "amazon")) &&
    process.env.REACT_APP_MODE === "development";

  const nextStep = [
    canAmazonIntegration && "amazon:do-you-sell-on-amazon",
    "other:do-you-sell",
  ].filter(Boolean)[0] as Step;

  return (
    <>
      <DialogTitle onClose={onClose}>Import in Process</DialogTitle>
      <MuiDialogContent>
        <DialogContentText>
          Congrats! Your sales import from Whatnot has started. Click continue
          set-up for your next steps.
        </DialogContentText>
      </MuiDialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onStepChange(nextStep);
          }}
          color="primary"
          autoFocus
        >
          Continue Set-Up
        </Button>
      </DialogActions>
    </>
  );
}

export default WhatnotImportInProcess;
